module.exports = __webpack_public_path__ + "aa7978ceccd30a56c239b3041405a15a.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Avdelare/img/student_desk_gray.gif
 ** module id = 461
 ** module chunks = 0
 **/